import { AxiosResponse } from 'axios'
import { SupportedLocales } from './types'
import { cabinetClient } from '@/entities/httpClient'

const urls = {
  supportLocales: '/locale/supported-locales',
  locale: (locale: string) => `/locale?locale=${locale}`,
  country: '/user-info/country',
}

export const localeApi = {
  async getSupportLocales(): Promise<AxiosResponse<SupportedLocales>> {
    return cabinetClient.request({
      url: urls.supportLocales,
      method: 'GET',
    })
  },
  async getLocale(locale: string) {
    return cabinetClient.request({
      url: urls.locale(locale),
      method: 'GET',
    })
  },
}

export const userInfoApi = {
  async getCounty(): Promise<AxiosResponse<string>> {
    return cabinetClient.request({
      url: urls.country,
      method: 'GET',
    })
  },
}
